require("./math");
require("sweetalert");

import Vue from 'vue'

/** Material Theme */
import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.min.css'

import Notifications from 'vue-notification'
import VueCurrencyFilter from 'vue-currency-filter'
//import VeeValidate from 'vee-validate';
import VueClipboard from 'vue-clipboard2'
import Toasted from 'vue-toasted';


import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-default.css';


VueClipboard.config.autoSetContainer = true;
import VueLazyload from 'vue-lazyload';

Vue.use(VueLazyload);
Vue.use(Notifications);
//Vue.use(VeeValidate, { events: 'change|blur' });
Vue.use(VueCurrencyFilter, {
	symbol : '$',
	thousandsSeparator: ',',
	fractionCount: 2,
	fractionSeparator: '.',
	symbolPosition: 'front',
	symbolSpacing: true
});

Vue.use(VueClipboard);
Vue.use(Toasted);
Vue.use(VueToast);
Vue.use(VueMaterial);

import './assets/style5.css'